<template>
	<ul class="home-social">
		<template v-for="button in socialButtons">
			<li>
				<a :href="button[1]"><i :class="button[2]" aria-hidden="true"></i><span>{{ $t('titles.' + button[0]) }}</span></a>
			</li>
		</template>
	</ul>
</template>

<script>
	// import params object
	import {params as SiteParams} from '../../params';

	// export
	export default {
		name: 'SocialButtonsTitles',
		data: function () {
			return {
				socialButtons: SiteParams.socialButtons
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/socialButtons/ButtonsTitles.vue